import React from 'react';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { withDynamicComponent, withDynamicImport } from '@thd-nucleus/app-render';
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';
import {
  Card,
  SkeletonBlock,
  SkeletonLine,
} from '@one-thd/sui-atomic-components';
import { Carousel } from '@one-thd/sui-carousel';
import { TrendingCategories } from '@thd-olt-component-react/thd-recs-containers';

const placeholderStyles = { height: '183px', width: '183px', alignSelf: 'center' }
const placeholder = (
  <Carousel
    key="placeholder"
    data-component="Trending Categories Importer"
    className="sui-col-span-12 sui-flex sui-align-center sui-justify-center sui-flex-col"
  >
    <Card>
      <SkeletonBlock aspect="square" style={placeholderStyles} />
      <SkeletonLine variant="single" />
    </Card>
    <Card>
      <SkeletonBlock aspect="square" style={placeholderStyles} />
      <SkeletonLine variant="single" />
    </Card>
    <Card>
      <SkeletonBlock aspect="square" style={placeholderStyles} />
      <SkeletonLine variant="single" />
    </Card>
    <Card>
      <SkeletonBlock aspect="square" style={placeholderStyles} />
      <SkeletonLine variant="single" />
    </Card>
    <Card>
      <SkeletonBlock aspect="square" style={placeholderStyles} />
      <SkeletonLine variant="single" />
    </Card>
  </Carousel>
);

const ImportedComponent = withDynamicImport({
  server: () => {
    return __webpack_require__(
      require.resolveWeak('@thd-olt-component-react/thd-recs-containers')
    ).TrendingCategories;
  },
  client: () => {
    return import(
      /* webpackPrefetch: true, webpackChunkName: "trending-categories-component" */
      '@thd-olt-component-react/thd-recs-containers');
  },
  placeholder,
  name: 'TrendingCategories',
});

const HydratedTrendingCategories = withHydrator({
  id: 'trending-categories',
  scrollBuffer: 300,
  delay: 1000,
  preserveCtxVal: 'clientStore',
  placeholder
}, ImportedComponent);

const TrendingCatsDynamic = withDynamicComponent(HydratedTrendingCategories);
const TrendingCategoriesImporter = withErrorBoundary(TrendingCatsDynamic);

TrendingCategoriesImporter.dataModel = TrendingCategories.dataModel;
TrendingCategoriesImporter.propTypes = TrendingCategories.propTypes;

export default TrendingCategoriesImporter;